import React, { Component }  from 'react';
import { HashRouter, Routes, Route } from "react-router-dom";
import './App.css';
import Home from './component/home';
import Demo from './component/demo';
import Topbar from './component/topbar';

function App() {
  return (
    <div className="App">
      <Topbar></Topbar>
      <Routes>
        <Route path="/" element={<Home></Home>}></Route>
        <Route path="/demo" element={<Demo></Demo>}></Route>
      </Routes>
    </div>
  );
}

export default App;
